<template>
	<div class="landStatistical">
		landStatistical
	</div>
</template>

<script>
	export default {
		name: 'landStatistical'
	}
</script>

<style scoped>

</style>
